import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {ThemeProvider} from '@mui/material/styles'
import {theme} from './settings/theme'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store/configureStore';

ReactDOM.render(
    
    <Provider store = { store }>
        <ThemeProvider theme={theme}>
        <App />
        </ThemeProvider>
    </Provider>, 
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
